import { render, staticRenderFns } from "./Antiriciclaggio.vue?vue&type=template&id=61386eba"
import script from "./Antiriciclaggio.vue?vue&type=script&lang=js"
export * from "./Antiriciclaggio.vue?vue&type=script&lang=js"
import style0 from "./Antiriciclaggio.vue?vue&type=style&index=0&id=61386eba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports